import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { setAccount, setSignInStep, SignInStep } from 'prequalificationV2/actions';
import Loader from 'components/Loader';
import useAppNavigate from 'hooks/useAppNavigate';
import { FailureNotificationType } from 'notifications';
import * as notificationManager from 'notifications';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import { AppRoutes } from 'prequalificationV2/routes/routes.enums';
import { authApi } from 'api/auth/AuthApi';
import { ResumeProcessLinkDestination } from 'api/auth/authApi.enums';

const ResumeProcessLink = () => {
  const dispatch = useAppDispatch();
  const navigator = useAppNavigate();
  const { search: query } = useLocation();

  const resolveLink = async () => {
    const token = new URLSearchParams(query).get('token');

    if (!token) {
      navigator(`${AppRoutes.Dashboard}${query}`);

      return;
    }

    try {
      const { destination, email, borrowerId } = await authApi.resolveResumeProcessLinkToken(token);

      if (destination === ResumeProcessLinkDestination.OtpVerification) {
        dispatch(setAccount({ id: borrowerId, email: email }));
        dispatch(setSignInStep(SignInStep.ResumeProcessOtpVerification));
        navigator(AppRoutes.Login);

        return;
      }

      if (localStorage.getItem('refreshToken')) {
        navigator(AppRoutes.Dashboard);

        return;
      }

      dispatch(setAccount({ email: email }));
      dispatch(setSignInStep(SignInStep.SignIn));
      navigator(AppRoutes.Login);
    } catch (error) {
      if (localStorage.getItem('refreshToken')) {
        navigator(AppRoutes.Dashboard);

        return;
      }

      notificationManager.notifyFailure(FailureNotificationType.ResumeProcessLinkExpired);
      navigator(AppRoutes.Prequalification);
    }
  };

  useEffect(() => {
    resolveLink();
  }, []);

  return <Loader />;
};

export default ResumeProcessLink;
